import { useButton1 } from "@/scripts/ui/buttons/Button1";
import { useButton2 } from "@/scripts/ui/buttons/Button2";
import { useAccordion1 } from "@/scripts/ui/accordions/Accordion1";
import { useAccordion2 } from "@/scripts/ui/accordions/Accordion2";
import { useDivider1 } from "@/scripts/ui/dividers/Divider1";
import { useSceneEntities } from "@/stores/SceneEntities";
import { useButtonRadioGroup } from "@/scripts/ui/ButtonRadioGroup";
export function useRoom() {
  const sceneEntities = useSceneEntities();
  let wallsRadioGroup = useButtonRadioGroup();

  let target = useAccordion1();
  target.attributes.componentData.display.label = "Room";
  target.attributes.componentData.key = "room";
  sceneEntities.addItemToUIList(target.attributes.componentData);

 
  //Invert Orientation--------------------------------------------------
  let invertOrientation = useButton1();
  target.attributes.componentData.addChild(invertOrientation);
  invertOrientation.attributes.componentData.key = "invertorientation";
  sceneEntities.addItemToUIList(invertOrientation.attributes.componentData);
  invertOrientation.attributes.componentData.display.label = "Invert Orientation";
  invertOrientation.attributes.componentData.interaction.actions["scene_update"] = true;

  
  return target;
}
